/**
 * 编辑
 * @author wutao
 * @date 2023-02-16
 */
 import React from 'react';
 import { connect } from 'dva';
 import { framework_tool, component_tool, utils_tool } from '@/tool';
 let { WizModal, WizComponent, WizForm, WizCheckbox, WizRow, WizCol,WizSpin,WizButton,WizInputNumber } = component_tool;
 let { WizContainer, WizReduxTemplate,modelUtils } = framework_tool;
 let { $$, checkStrLength } = utils_tool;
 import '../../../../styles/containers/train/path/requirement/style.less'
 class UpdatePositionAuthState extends WizContainer {

   componentName = 'UpdatePositionAuthState';

   constructor(props) {
    super(props)
    let { record,lookState } = props
    this.state = {
        record,
        positionAuthState : null,
        positionAuthScore : null,
        timestamp: new Date().getTime(),
        lookState : lookState
    }
}

   _componentDidMount() {

   }

   _recordColumns = (record = {}) => {
    return [
        {
            title: '认证人员',
            name: 'name',
            formItem: {
                type: 'custom',
                render: () => {
                    return <div>{record.positionName}-{record.fullName}</div>
                }
            }
        },
        {
          title: '认证分数',
          name: 'positionAuthScore',
          formItem: {
            type: 'custom',
            render: (record, form) => {
              const { getFieldDecorator } = form
              return (
                <WizRow>
                  <WizCol span={12}>
                    {
                      getFieldDecorator('positionAuthScore', {
                        rules: [{ required: true, message: '请输入分数' }],
                        initialValue: record['positionAuthScore']
                      })(
                        <WizInputNumber min={0} max={100} size='middle' precision={1} disabled={this.state.lookState}
                        onChange={(value) => {
                          this.setState({
                            positionAuthScore: value
                          })
                        }
                        }
                        />
                      )
                    }
                  </WizCol>
                </WizRow>
              )
            }
        }
      },
        {
            title: '认证结果',
            name: 'positionAuthState',
            dict: [
                { code: 0, codeName: '合格' },
                { code: 1, codeName: '不合格' }
            ],
            formItem: {
                type: 'radio',
                rules: [
                  {
                    required: true,
                    message: '请选择认证结果'
                  },
                ],
                onChange: (form, value, e) => this.setState({ positionAuthState: value }),
                disabled : this.state.lookState
            }
        },

    ]
}

   propsAndStateOnChange = {
    saveOrUpdateState: this._saveOrUpdateState.bind(this),
   };

   _saveOrUpdateState(nextProps, nextState) {
     if (nextProps.saveOrUpdateState.code === 1) {
       wizNotice.success('保存成功');
       if (nextProps.onChangeTimestamp){
         nextProps.onChangeTimestamp();
       }
       nextProps.changeModal(false);
     } else {
       wizNotice.error(nextProps.saveOrUpdateState.msg);
     }
   }

   _onSave = () => {
     let form = this.formData;
     if (form){
       form.validateFields((err, values) => {
         if (!err) {
           let {record,positionAuthState,positionAuthScore } = this.state
           if(positionAuthState!=1 && positionAuthState!=0){
             wizNotice.warn('认证结果不可为空');
             return;
           }
           const {orgId,positionId,personId} = record // positionAuthState benchmarkState
           this.doAction({
             path: 'requirementPersonnelDetail/saveOrUpdateState',
             payload: {
               key: 'dealerSaveOrUpdateState',
               apiParams: {
                 orgId,positionId,personId,positionAuthState,positionAuthScore
               }
             }
           })
         }
       });
     }
   }

_renderFooter = () => {
  return (
      <React.Fragment>
          <WizRow className="form-btns row-item">
              <WizCol span={24}>
                  <WizButton title='保存' type='primary' onClick={() => this._onSave()}>确认</WizButton>
                  <WizButton title='重置' type='reset' onClick={() =>this.props.changeModal(false)}>取消</WizButton>
              </WizCol>
          </WizRow>
      </React.Fragment>
  )
}


   render() {
     const {requirementRecordLoading } = this.props;
     let {record, timestamp,lookState } = this.state
     let columns = this._recordColumns(record)
    // let onSubmit = this._onSave.bind(this);
     let formProps = {
      ref: 'formRef',
      key: timestamp,
      columns,
      record: record || { status: 0 },
     // preview: false,
      footer: lookState ? null :this._renderFooter(),
      formItemLayout: {
          labelCol: { span: 5 },
          wrapperCol: { span: 16 }
      }
  }
     return <WizForm {...formProps} ref={r => {
       this.formData = r
     }}/>
   }
 }

 const mapStateToProps = (state, ownProps) => {
   const { requirementPersonnelDetail } = state;
   const saveOrUpdateState = modelUtils.getModelEntity(requirementPersonnelDetail, 'dealerSaveOrUpdateState');
   const load = modelUtils.getLoadingState(state, "requirementPersonnelDetail");
   return {
    saveOrUpdateState,
     ...load,
   };
 };

 export default connect(mapStateToProps)(UpdatePositionAuthState);

